import { SERVICES } from '@/lib/api';
import { ArrowUpRight } from 'lucide-react';

const FEATURED = [
    {
        ...SERVICES.find(s => s.id === 'vip'),
        image: 'https://images.unsplash.com/photo-1502635385003-ee1e6a1a742d?crop=entropy&cs=srgb&fm=jpg&q=85',
        size: 'md:col-span-2 md:row-span-2',
    },
    {
        ...SERVICES.find(s => s.id === 'gare-aeroport'),
        image: 'https://images.unsplash.com/photo-1574202141112-c3a90e1a3ce2?crop=entropy&cs=srgb&fm=jpg&q=85',
        size: 'md:col-span-2',
    },
    {
        ...SERVICES.find(s => s.id === 'chauffeur-prive'),
        image: 'https://images.unsplash.com/photo-1765171103239-b4ce1f941910?crop=entropy&cs=srgb&fm=jpg&q=85',
        size: 'md:col-span-2',
    },
];

export const Services = () => {
    const featuredIds = FEATURED.map(f => f.id);
    const rest = SERVICES.filter(s => !featuredIds.includes(s.id));

    return (
        <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-[#050505] relative noise-overlay">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
                    <div>
                        <div className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-4">Nos prestations</div>
                        <h2 className="font-display text-4xl sm:text-5xl text-[#F8F8F5] font-light tracking-tight">
                            Un service complet,<br /><span className="italic text-[#C5A059]">sur-mesure</span>
                        </h2>
                    </div>
                    <p className="text-[#A3A39D] text-sm max-w-md leading-relaxed">
                        Que ce soit pour un déplacement urbain, un transfert aéroport ou un événement d'exception, Arnoux & co Taxi adapte chaque trajet à vos exigences.
                    </p>
                </div>

                {/* Bento Grid Featured */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 auto-rows-[200px]">
                    {FEATURED.map((s) => (
                        <div
                            key={s.id}
                            data-testid={`service-featured-${s.id}`}
                            className={`relative overflow-hidden group cursor-pointer ${s.size}`}
                        >
                            <img src={s.image} alt={s.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
                            <div className="relative h-full p-8 flex flex-col justify-end">
                                <div className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-2">Premium</div>
                                <h3 className="font-display text-2xl md:text-3xl font-light text-[#F8F8F5]">{s.title}</h3>
                                <p className="text-sm text-[#A3A39D] mt-2 max-w-sm">{s.description}</p>
                            </div>
                            <ArrowUpRight className="absolute top-6 right-6 text-[#C5A059] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" size={20} />
                        </div>
                    ))}
                </div>

                {/* Compact list */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#222]">
                    {rest.map((s) => (
                        <div
                            key={s.id}
                            data-testid={`service-${s.id}`}
                            className="bg-[#050505] p-8 hover:bg-[#0a0a0a] transition-colors group cursor-pointer"
                        >
                            <div className="flex items-start justify-between">
                                <h3 className="font-display text-xl text-[#F8F8F5] font-light leading-tight">{s.title}</h3>
                                <ArrowUpRight className="text-[#A3A39D] group-hover:text-[#C5A059] transition-colors" size={16} />
                            </div>
                            <p className="text-sm text-[#A3A39D] mt-3 leading-relaxed">{s.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
